import makeStyles from '@material-ui/core/styles/makeStyles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  form: {
    width: '100%'
  },
  bannerImageInput: {
    width: '100%',
    height: 196,
  },
  giftCardImageWrapper: {
    marginRight: ({ direction }: LayoutDirection) => direction === "rtl" ? 0: theme.spacing(15),
    marginLeft: ({ direction }: LayoutDirection) => direction === "rtl" ? theme.spacing(15): 0,
  },
  cardImageInput: {
    width: 490,
    height: 314,
  },
  bottomControls: {
    width: '40%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& > button': {
      flex: 0.485,
    },
  },
  input: {
    marginTop: 32,
  },
  addButton: {
    textTransform: 'capitalize',
  },
  validityCardContainer: {
    width: '194px',
  },
}));
